import { Networkish, SupStoredData, SupStoredFavToken, SupStoredFilter } from "@/types";

/**
 * Shorthand for the withdrawal in cart
 *
 * @param {SupStoredData} stored
 * @param {number} vault_id
 * @param {Networkish} chainId
 * @param {boolean} is_erc20
 * @return {boolean}
 */
export const checkWithdrawalStored = (stored: SupStoredData, vault_id: string, chainId: Networkish | undefined = undefined, is_erc20: boolean | undefined = undefined): boolean => {
  return (
    stored.withdrawCart.find(withdrawItem => {
      return withdrawItem.vault_id === vault_id && (chainId === undefined || withdrawItem.chainId === chainId) && (is_erc20 === undefined || withdrawItem.is_erc20 === is_erc20);
    }) !== undefined
  );
};

/**
 * Shorthand to check token against pinned tokens
 *
 * @param {SupStoredFavToken[]} storedTokens
 * @param {SupStoredFavToken} token
 * @return {boolean}
 */
export const checkFavToken = (storedTokens: SupStoredFavToken[], token: SupStoredFavToken): boolean => {
  return storedTokens.find(storedToken => storedToken.chainId == token.chainId && storedToken.tokenAddress === token.tokenAddress) !== undefined;
};

/**
 * Shorthand to get applied filters count
 *
 * @param {SupStoredFilter[]} filters
 * @param {string | undefined} filterName
 *
 * @return {number}
 */
export const countFilters = (filters: SupStoredFilter[], filterName: string | undefined = undefined): number => {
  if (!filterName) {
    return filters.reduce((accumulator, currentValue) => accumulator + (Array.isArray(currentValue.values) ? currentValue.values.length : 1), 0);
  } else {
    const foundValues = filters.find(filter => filter.name === filterName)?.values;
    return foundValues ? (Array.isArray(foundValues) ? foundValues.length : 1) : 0;
  }
};
